import { Box, CircularProgress, Typography, Skeleton, Stack } from '@mui/material';

export function LoadingState({ label = 'Loading...', minHeight = 240 }) {
  return (
    <Box
      sx={{
        minHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        color: 'text.secondary',
      }}
    >
      <CircularProgress size={32} />
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
}

export function SkeletonRows({ rows = 5 }) {
  return (
    <Stack spacing={1.5} sx={{ py: 1 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={48} />
      ))}
    </Stack>
  );
}

export default LoadingState;
